import { render, staticRenderFns } from "./Coefficienti.vue?vue&type=template&id=3f873dd6&"
import script from "./Coefficienti.vue?vue&type=script&lang=js&"
export * from "./Coefficienti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports